import { CurrencyCode } from '@/helpers/currency';

export const mapCurrencyToMaxAmount: Record<string, number> = {
  [CurrencyCode.USD]: 3000,
  [CurrencyCode.EUR]: 3000,
  [CurrencyCode.CAD]: 3000,
  [CurrencyCode.AUD]: 3000,
  [CurrencyCode.NZD]: 3000,
};
